import { TranslationObject } from '../../i18n/translation';

const namespace = 'agreementcontent';
const translations: TranslationObject = {
  pdfFileInputModalTitle: {
    id: `${namespace}.pdfFileInputModalTitle`,
    nb: 'Last opp vedlegg til samarbeidsavtalen',
    en: 'Upload attachments to the collaboration agreement',
  },
  pdfFileInputModalSubtitle: {
    id: `${namespace}.pdfFileInputModalSubtitle`,
    nb: 'Her kan du laste opp vedlegg (.pdf-filer) som hører til samarbeidsavtalen. Man kan laste opp ett dokument for selve samarbeidsavtalen, ett dokument for databehandleravtalen og et valgfritt antall andre vedlegg.',
    en: 'Upload attachments describing the collaboration agreement. You may upload one document for the collaboration agreement, one document for the data processing agreement, and a optional number of other attachments.',
  },
  pdfFileInputLabelPrefix: {
    id: `${namespace}.pdfFileInputLabelPrefix`,
    nb: 'Dra og slipp PDF-filen her, eller ',
    en: 'Drag and drop the PDF file here, or ',
  },
  pdfFileInputLabelLink: {
    id: `${namespace}.pdfFileInputLabelLink`,
    nb: 'velg fra datamaskinen.',
    en: 'choose file from computer.',
  },
  pdfFileInputLabelSuffix: {
    id: `${namespace}.pdfFileInputLabelSuffix`,
    nb: ' (Maks. filstørrelse er {maxSize}MB)',
    en: ' (Max. file size is {maxSize}MB)',
  },
  pdfFileInputNameFieldLabel: {
    id: `${namespace}.pdfFileInputNameFieldLabel`,
    nb: 'Nytt navn for vedlegget:',
    en: 'New name of the attachment:',
  },
  pdfFileInputNameFieldPlaceholder: {
    id: `${namespace}.pdfFileInputNameFieldPlaceholder`,
    nb: '(Navnet på opplastet fil vil brukes automatisk. Kan endres manuelt her etter opplasting.)',
    en: '(Fetched automatically from file name. Can be edited manually here after upload.)',
  },
  upload: {
    id: `${namespace}.upload`,
    nb: 'Last opp',
    en: 'Upload',
  },
  cancel: {
    id: `${namespace}.cancel`,
    nb: 'Avbryt',
    en: 'Cancel',
  },
  addAvtaleAttachment: {
    id: `${namespace}.addAvtaleAttachment`,
    nb: 'Last opp nytt avtalevedlegg',
    en: 'Upload new agreement attachment',
  },
  deleteAvtaleAttachments: {
    id: `${namespace}.deleteAvtaleAttachments`,
    nb: 'Fjern alle avtalevedlegg',
    en: 'Remove all agreement attachments',
  },
  attachment: {
    id: `${namespace}.attachment`,
    nb: 'Avtalevedlegg',
    en: 'Agreement attachment',
  },
  alreadySignedCheckbox: {
    id: `${namespace}.alreadySignedCheckbox`,
    nb: 'Avtalen er allerede signert av alle parter.',
    en: 'The agreement is already signed by all parties.',
  },
  sharePersonnummerCheckbox: {
    id: `${namespace}.sharePersonnummer`,
    nb: 'Tillat administratorer ved praksisstedene å laste ned studentlister med fødselsnummer, etter gjennomført studentfordeling.',
    en: 'Allow administrators at the workplaces to download studentlists containing national identity numbers, after assigning work placements.',
  },
  vedleggstype: {
    id: `${namespace}.vedleggstype`,
    nb: 'Vedleggstype',
    en: 'Attachement type',
  },
  handling: {
    id: `${namespace}.handling`,
    nb: 'Handling',
    en: 'Action',
  },
  samarbeidsavtale: {
    id: `${namespace}.samarbeidsavtale`,
    nb: 'Samarbeidsavtale',
    en: 'Collaboration agreement',
  },
  databehandleravtale: {
    id: `${namespace}.databehandleravtale`,
    nb: 'Databehandleravtale',
    en: 'Data processing agreement',
  },
  annet: {
    id: `${namespace}.annet`,
    nb: 'Annet',
    en: 'Other',
  },
  deleteVedlegg: {
    id: `${namespace}.deleteVedlegg`,
    nb: 'Slett vedlegget',
    en: 'Delete attachment',
  },
  warning: {
    id: `${namespace}.warning`,
    nb: 'Advarsel',
    en: 'Warning',
  },
  deleteSubmit: {
    id: `${namespace}.deleteSubmit`,
    nb: 'Slett vedlegg',
    en: 'Delete attachment(s)',
  },
  replaceSubmit: {
    id: `${namespace}.replaceSubmit`,
    nb: 'Erstatt { type }',
    en: 'Replace { type }',
  },
  deleteWarning: {
    id: `${namespace}.deleteWarning`,
    nb: 'Er du sikker på at du vil slette vedlegget? Dette kan ikke angres, etter at avtalen er lagret.',
    en: 'Are you sure that you want to delete the chosen attachment? This cannot be undone, after the agreement has been saved.',
  },
  deleteAllWarning: {
    id: `${namespace}.deleteAllWarning`,
    nb: 'Du er i ferd med å slette ALLE vedlegg for denne avtalen. Er du sikker på at du vil fortsette? Dette kan ikke angres, etter at avtalen er lagret.',
    en: 'You are about to delete all attachment for this agreement. Are you sure that you want to continue? This cannot be undone, after the agreement has been saved.',
  },
  replaceWarning: {
    id: `${namespace}.replaceWarning`,
    nb: 'Du er i ferd med å skrive over { type }, med et nytt vedlegg. Er du sikker på at du ønsker å erstatte vedlegget? Dette kan ikke angres, etter at avtalen er lagret.',
    en: 'You are about to replace the { type } attachment. Are you sure that you want to continue? This cannot be undone, after the agreement has been saved.',
  },
};

export default translations;
